import { useQuery } from '@apollo/client';
import { LoadingOrError } from '@retainerclub/common';
import { CustomerCard } from '@retainerclub/customer-shared';
import { useAuth } from '@retainerclub/hooks';
import { GET_SCHEDULED_SHIPMENTS } from '@retainerclub/shared-api';
import { useEffect, useState } from 'react';
import DashboardSchedulesTable from './DashboardSchedulesTable';

function DashboardSchedules() {
  const [schedules, setSchedules] = useState([]);
  const { currentUser } = useAuth();

  const { loading, error, refetch, data } = useQuery(GET_SCHEDULED_SHIPMENTS, {
    skip: currentUser === null || currentUser === undefined,
  });

  useEffect(() => {
    if (data?.scheduledShipments?.length > 0) {
      const filteredSchedules = data.scheduledShipments.filter(
        (schedule) => schedule.consumed === false,
      );
      setSchedules(filteredSchedules);
    }
  }, [data]);

  const shouldRender = LoadingOrError({
    loading,
    error,
    title: 'Schedules',
  });

  if (shouldRender) {
    return (
      <CustomerCard
        title="Schedule"
        description="Your schedule of upcoming retainers shipped right to your door."
      >
        <DashboardSchedulesTable schedules={schedules} refetch={refetch} />
      </CustomerCard>
    );
  }

  return shouldRender;
}

export default DashboardSchedules;
